<template>
  <div class="vipwrap">
    <div v-if="userinfo" class="vipPage">
      <div class="navheader">
        <div class="navtitle">
          <img class="headimgUrl" :src="userinfo.headimgUrl" alt="" />
          {{ userinfo.nickName }}
        </div>
        <!-- <div class="backhome"><van-icon name="home-o"></van-icon></div> -->
        <!-- <div class="backhome">
          <div @click="returnback" class="returnback">
            返回 <img src="../../assets/img/returnBack.png" alt="" />
          </div>
          <van-button to="/plate" type="info" size="small">首 页</van-button>
        </div> -->
      </div>
      <vipinfos :userinfo="userinfo" :createPostInfos="createPostInfos"></vipinfos>
      <div class="vipSection">
        <div class="viptab viptypetab ">
          <div v-for="(item, index) in vipTypeList" :key="index" :class="vipTypeListIndex == index ? 'ac' : ''"
            class="item" @click="!loading && changeVipType(index)">
            <div v-if="index < 2" class="rline"></div>
            <!-- <div v-if="index == 0" class="acright">最划算</div> -->
            <!-- <div v-if="index == 0" class="acright">仅{{ toFixed(item.salesPrice / 432) }}元/天</div> -->
            <!-- <div v-if="index == 0" class="acright">仅0.38元/天</div> -->
            <!-- <div class="t">{{ item.title }}</div> -->
            <div style="position: relative;" class="price">
              <img class="imgicon" style="margin-right: 5px;" :src="item.icon" alt="" />{{
                item.title
              }}
              <div class="smsize" v-if="index == 2">&nbsp;(须一尘会员)</div>
            </div>
            <div v-if="vipTypeListIndex == index" class="triangle"></div>
            <!-- <div style="color:#c9a36b" class="origin">{{ item.sellPoint }}&nbsp;</div> -->
            <!-- <div class="origin">活动钜惠价:￥{{ item.marketPrice}}</div> -->
            <!-- <div class="origin">原价：￥{{ item.marketPrice }}</div> -->

            <!-- <div class="s">立省{{ item.marketPrice - item.salesPrice }}元</div> -->
          </div>
        </div>

        <div class="viptab">
          <div v-for="(item, index) in list" :key="index" :class="vipindex == index ? 'ac' : ''" class="item"
            @click="!loading && (vipindex = index)">
            <!-- <div v-if="index == 0" class="acright">最划算</div> -->
            <!-- <div v-if="index == 0" class="acright">仅{{ toFixed(item.salesPrice / 432) }}元/天</div> -->
            <!-- <div v-if="index == 0" class="acright">{{ countFun(item) }}</div> -->
            <div v-if="item.description" class="acright">专属八折</div>
            <div v-else-if="index == 0 && vipTypeListIndex == 0" class="acright">最优惠</div>
            <div class="t">{{ item.name }}</div>
            <div class="price">￥{{ item.salesPrice }}</div>
            <div class="origin">{{ item.sellPoint }}&nbsp;</div>
            <!-- <div class="origin">活动钜惠价:￥{{ item.marketPrice}}</div> -->
            <div v-if="item.description" style="text-decoration: line-through;" class="origin">
              原价：￥{{ item.marketPrice }}
            </div>
            <!-- <div  class="s">{{ item.marketPrice - item.salesPrice }}元</div> -->
            <div v-if="item && item.stock && item.stock == 0" class="stock stockno">
              已售罄
            </div>
            <div v-else-if="item && item.stock && item.stock < 100" class="stock">
              库存紧张
            </div>
          </div>
        </div>

        <!-- 多种类vip -->
        <div v-if="false" class="setion">
          <div class="title">会员功能选项</div>
          <van-checkbox-group style="font-size: 12px;margin-bottom: 20px;" @change="vipCategorySecondFun"
            v-model="isCheckVipCode">
            <van-checkbox shape="square" style="margin-bottom:10px" name="1511525286394716162">
              <img class="vipicon" src="../../assets//img/dicon.png" alt="" />
              一尘盯盘提醒(买/卖/成交贴提醒/搜索帖子)</van-checkbox>
            <van-checkbox shape="square" name="1511525286394716163">
              <img class="vipicon" src="../../assets/img/ft.png" alt="" /> 一尘发帖助手(手机一键发帖
              一键上图)
            </van-checkbox>
          </van-checkbox-group>
        </div>

        <div v-if="vipTypeListIndex == 0 || vipTypeListIndex == 2" @click="handleTips" class="registerTips">
          没有一尘卖家账号?
        </div>
        <van-button @click="alertTip" loading-type="spinner"
          :disabled="this.list[this.vipindex]?.stock == 0 ? true : false" :loading="loading" class="submit" block>
          {{
            (vipTypeListIndex == 1 && !userinfo.vipExpireTime) ||
              (vipTypeListIndex == 2 && !createPostInfos) ||
              (vipTypeListIndex == 0 && !createPostInfos) ||
              (vipTypeListIndex == 0 && !userinfo.vipExpireTime)
              ? `开通${vipTypeListIndex == 0
                ? '超级会员'
                : vipTypeListIndex == 1
                  ? '盯盘会员'
                  : '发帖会员'
              }`
              : `续费${vipTypeListIndex == 0 ? '超级' : vipTypeListIndex == 1 ? '盯盘' : '发帖'
              }会员`
          }}</van-button>
        <van-divider v-if="userinfo.isReceive == 0" content-position="right"
          :style="{ color: '#e94d4a', borderColor: '#e94d4a', margin: 0, marginBottom: '25px' }">
          <template v-if="!isActivity" #default>
            <van-button @click="userGetFreeVip" class="scaleDraw" size="mini" plain
              type="info">点我，立即免费获得7天会员</van-button>
          </template>
          <template v-else #default>
            <van-button class="scaleDraw" size="mini" plain type="info">6月16日-6月21日，开通/续费 即额外赠送一个月</van-button>
          </template>
        </van-divider>

        <div class="setion">
          <div style="color:red" class="h">如无法支付，请点击右上角“...” 刷新</div>

          <template v-if="isCheckVipCode.length == 2">
            <div class="title">
              <img class="iconimg" :src="vipTypeList[0].icon" alt="" /> 超级会员尊享
            </div>
            <div class="h">1.一尘盯盘助手</div>
            <div class="s">可订阅求购贴、出售贴、成交贴实时推送提醒。</div>
            <div class="h">2.一尘发帖助手</div>
            <div class="s">手机操作一键发帖，一键回复，超级方便</div>
          </template>
          <template v-if="isCheckVipCode.length == 1 && isCheckVipCode[0] == '1511525286394716162'">
            <div class="title">
              <img class="iconimg" :src="vipTypeList[1].icon" alt="" /> 一尘盯盘会员尊享
            </div>
            <div class="h">1.新帖实时提醒</div>
            <div class="s">可订阅求购贴、出售贴、成交贴实时推送提醒。</div>
            <div class="h">2.帖子搜索/浏览</div>
            <div class="s">可按照最新时间查询帖子，可以按照买/卖/成类型查看帖子</div>
            <div class="h">3.使用说明</div>
            <div class="s">
              为了保证推送准确，订阅关键字只限添加一个品种。多个品种请添加多条。关键字不要出现空格、符号等内容(影响推送)
            </div>
          </template>
          <template v-if="isCheckVipCode.length == 1 && isCheckVipCode[0] == '1511525286394716163'">
            <div class="title">
              <img class="iconimg" :src="vipTypeList[2].icon" alt="" /> 一尘发帖会员尊享
            </div>
            <div class="h">1.使用说明</div>
            <div class="s">
              需绑定一尘账号，一尘账号为<span style="color:red;font-size: 14px;font-weight: bold;">
                一尘网卖家会员 </span>有发帖权限
            </div>
            <div class="h">2.手机一键发帖</div>
            <div class="s">手机操作一键发帖，一键回复，超级方便，一键评分</div>
            <div class="h">3.发帖上图</div>
            <div class="s">可选择相册图片/相机拍摄，帖子一键上图 上图无困扰</div>
          </template>
        </div>
      </div>
    </div>

    <r-page></r-page>
  </div>
</template>
<script>
import { getGoods, orderinfo, unifiedOrder, wxuser, getFreeVip } from '@/api/base';

import { formatDateTimeRT, setFormateDateEnd } from '@/utils/index';
import { isPcClient } from '../PC/utils';

import vipinfos from '../components/vipinfos.vue';
import RPage from '../components/rPage.vue';
// import wx from 'weixin-js-sdk';
export default {
  components: {
    vipinfos,
    RPage,
  },
  data() {
    return {
      vipindex: 0,
      list: [],
      userinfo: null,
      loading: false,
      res: null,
      isActivity: this.$store.state.app.isActivity,
      option: [
        //发帖会员 1511525286394716163  盯盘会员 1511525286394716162 联合会员 1511525286394716164
        { title: '一尘盯盘会员', type: 0 },
        { title: '实用工具会员', type: 1 },
      ],
      vipTypeList: [
        { title: '超级会员', type: 2, icon: require('../../assets/img/svip2.png') },
        { title: '盯盘会员', type: 0, icon: require('../../assets/img/svip3.png') },
        { title: '发帖会员', type: 1, icon: require('../../assets/img/svip1.png') },
      ],
      vipTypeListIndex: 0,
      active: 0,
      vipCompress: null,
      vipCategorySecond: '1511525286394716164',
      isCheckVipCode: ['1511525286394716162', '1511525286394716163'],
      createPostInfos: null,
    };
  },
  created() {
    this.init();
    this.getUserinfo();
  },
  methods: {
    handleTips() {
      window.location.href = 'https://ui.smartrecorder.xyz/#/adView?r=1';
    },
    returnback() {
      window.history.back();
    },
    changeVipType(index) {
      this.vipTypeListIndex = index;
      switch (index) {
        case 0: //超级会员
          this.isCheckVipCode = ['1511525286394716162', '1511525286394716163'];
          break;
        case 1: //超级会员
          this.isCheckVipCode = ['1511525286394716162'];
          break;
        case 2: //超级会员
          this.isCheckVipCode = ['1511525286394716163'];
          break;
        default:
          break;
      }
      this.vipCategorySecondFun();
    },
    init() {
      getGoods({
        current: 1,
        size: 10,
        inComeOpenId: this.$route.query.icoi || null,
        categorySecond: this.vipCategorySecond,
        // stock: '999999',
        ascs: 'sort', //升序字段
        // descs: 'sale_num',
      }).then(res => {
        this.list = res.data.records;
      });
    },
    vipCategorySecondFun(e) {
      if (this.isCheckVipCode.length > 1) {
        this.vipCategorySecond = '1511525286394716164';
      } else if (this.isCheckVipCode.length == 1) {
        this.vipCategorySecond = this.isCheckVipCode[0];
      } else {
        this.vipCategorySecond = '1511525286394716162';
        this.isCheckVipCode = ['1511525286394716162'];
      }
      this.init();
    },
    getUserinfo() {
      wxuser().then(res => {
        res.data.wxUser.isVip = 0;
        let now = new Date().getTime() / 1000;
        res.data.vipInfos.map(item => {
          if (item.vipType == 1) {
            if (now < new Date(item.validityTime).getTime() / 1000) {
              res.data.wxUser.isVip = 1;
            }
            res.data.wxUser.vipExpireTime = setFormateDateEnd(item.validityTime);
          }
          if (item.vipType == 2) {
            item.validityTime = setFormateDateEnd(item.validityTime);
            this.vipCompress = item;
          }
          if (item.vipType == 3) {
            item.validityTime = setFormateDateEnd(item.validityTime);
            this.createPostInfos = item;
          }
        });
        this.userinfo = res.data.wxUser;
        this.$store.commit('setUserinfo', res.data.wxUser);
      });
    },
    isExpire(date) {
      if (!date) {
        return false;
      }
      let now = new Date().getTime();
      return !(now < new Date(date).getTime());
    },
    alertTip() {
      let that = this;
      // PC端无法调用微信JSSDK支付，提示用户到手机端操作
      if (isPcClient()) {
        this.$dialog.alert({
          title: '请在手机端操作',
          message:
            '当前为电脑端浏览，暂不支持在线支付开通/续费会员。\n请使用手机微信打开本页面进行支付。',
          confirmButtonText: '我知道了',
        });
        return;
      }
      let len = this.isCheckVipCode.length;
      let title =
        len == 2
          ? '确定开通超级会员？'
          : len == 1 && this.isCheckVipCode[0] == '1511525286394716162'
            ? '确定开通一尘盯盘提醒？'
            : '确定开通一尘发帖助手？';
      let content =
        len == 2
          ? '(盯盘提醒+发帖助手)'
          : len == 1 && this.isCheckVipCode[0] == '1511525286394716162'
            ? '(买/卖/成交贴提醒)'
            : '(手机一键发帖 一键上图)';
      this.$dialog
        .confirm({
          title: title,
          message: content,
        })
        .then(() => {
          // on confirm
          that.submit();
        })
        .catch(() => {
          // on cancel
        });
    },

    submit() {
      this.loading = true;
      let params = this.list[this.vipindex];
      let obj = {
        userAddressId: '1492063278006247425',
        paymentType: '1',
        deliveryWay: '',
        skus: [
          {
            spuId: params.id,
            quantity: 1,
            paymentPrice: params.salesPrice,
            freightPrice: 0,
          },
        ],
      };
      orderinfo(obj).then(response => {
        let that = this;
        var ua = navigator.userAgent.toLowerCase();
        // 判断是否在微信浏览器内
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          wx.miniProgram.getEnv(wechat => {
            if (wechat.miniprogram) {
              console.log('在小程序内');
              let id = response.data.id;
              wx.miniProgram.navigateTo({
                url: '/pages/order/index?id=' + id, // id:所需参数（动态参数需放在引号外小程序才可识别）
                success: res => {
                  console.log(res); // 页面跳转成功的回调函数
                },
                fail: err => {
                  console.log(err); // 页面跳转失败的回调函数
                },
              });
            } else {
              console.log('不在小程序内');
              unifiedOrder(
                { id: response.data.id, inComeOpenId: that.$route.query.icoi || null },
                'wx6ced2d8b252a0ff2',
              ).then(res => {
                wx.chooseWXPay({
                  timestamp: res.data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                  nonceStr: res.data.nonceStr, // 支付签名随机串，不长于 32 位
                  package: res.data.packageValue, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                  signType: res.data.signType, // 微信支付V3的传入RSA,微信支付V2的传入格式与V2统一下单的签名格式保持一致
                  paySign: res.data.paySign, // 支付签名
                  success: function (res) {
                    // 支付成功后的回调函数
                    console.log(res);
                    that.res = res;
                    that.getUserinfo();
                    that.loading = false;
                  },
                  success: function (r) {
                    // 支付成功后的回调函数
                    if (r.errMsg == 'chooseWXPay:ok') {
                      that.$toast('支付成功！');
                    }
                    that.getUserinfo();

                    that.loading = false;
                    if (this.$route.query.r) {
                      window.location.href = decodeURIComponent(
                        decodeURIComponent(this.$route.query.r),
                      );
                      return;
                    }
                  },
                  cancel: function (r) {
                    that.loading = false;
                    that.getUserinfo();
                  },
                  fail: function (r) {
                    that.loading = false;
                  },
                });
              });
            }
          });
        }
      });
    },
    userGetFreeVip() {
      getFreeVip().then(res => {
        this.$toast('恭喜您领取成功！');
        this.getUserinfo();
      });
    },
    toggle() {
      this.init();
    },
    countFun(item) {
      console.log(item);
      let price = item.salesPrice / 365;
      return `仅${price.toFixed(2)}元/天`;
    },
  },
  mounted() { },
};
</script>
<style lang="less" scoped>
.vipwrap {
  background: url('../../assets//img/vipHeaderbg.jpg') top no-repeat;
  width: 100%;
  background-size: 100% auto;
  padding-bottom: 50px;

  .vipPage {
    padding: 20px 16px;
  }
}

.vipSection {
  background: #fff;
  border-radius: 12px;
  padding: 20px 15px;
  padding-top: 0;
}

.navheader {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;

  .backhome {
    font-size: 14px;
    color: #fff;

    img {
      width: 22px;
      // height: 23px;
      margin-left: 4px;
    }

    .van-icon-home-o {
      border: 1px solid #fff;
      border-radius: 5px;
    }
  }
}

.navtitle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 18px;
  color: #fff;
}

.viptab {
  display: flex;
  justify-content: space-between;
  margin-bottom: 17px;
}

.viptab .item {
  flex: 1;
  text-align: center;
  /* width: 110px; */
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 15px 0 10px 0;
  border: 1px solid rgba(227, 239, 249, 1);
  margin-right: 6px;
  box-sizing: border-box;
}

.viptab .item :last-child {
  margin-right: 0;
}

.viptab .item.ac {
  //   border: 2px solid #ddc996;
  //   background: #fcf3ea;
  background: rgba(250, 245, 197, 1);
  border: 1px solid rgba(227, 239, 249, 1);
}

.viptypetab .item {
  //   padding: 10px;
  background: transparent;
  border: none;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 21.95px;
}

.viptypetab .item .rline {
  width: 1px;
  height: 24px;
  opacity: 1;
  background: rgba(217, 217, 217, 1);
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

.viptypetab .item .triangle {
  width: 30px;
  height: 1px;
  border-bottom: 3px solid rgba(212, 48, 48, 1);
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-25%);
}

.viptypetab img.imgicon {
  width: 15px;
  margin-right: 5px;
}

.viptypetab .item.ac {
  color: #333;
  /* border: 2px solid #dcdee0b5; */
  background: transparent;
  border: none;
  color: rgba(121, 72, 234, 1);
}

.swipertab .item {
  position: relative;
}

.swipertab .item .img {
  width: 100%;

  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 4px;
}

.viptab .item .acright {
  position: absolute;
  right: -1px;
  top: -7px;
  background: #e94d4a;
  color: #fff;
  font-size: 12px;
  width: 70px;
  height: 16px;
  border-top-right-radius: 5px;
  border-bottom-left-radius: 5px;
}

.viptab .item .t {
  color: #333;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

.viptab .item .price text {
  font-size: 10px;
}

.viptab .item .price {
  font-size: 14px;
  font-weight: 600;
  //   color: #c9a36b;
  color: #333;
  margin-bottom: 8px;
}

.viptypetab .item .price {
  font-size: 16px;
  color: rgba(128, 128, 128, 1);
}

.viptypetab .item.ac .price {
  color: rgba(121, 72, 234, 1);
}

.viptab .item .origin {
  /* color: #c9cac1; */
  color: #e94d4a;
  font-size: 10px;
  margin-bottom: 7px;
}

.viptab .item .stock {
  background: #fff;
  color: red;
  border-radius: 15px;
  margin: 0 auto;
  font-size: 13px;
  padding: 4px 10px;
  display: inline-block;
  border: 1px solid #edd5a7;
}

.viptab .item .stockno {
  color: dimgray;
  border: 1px solid dimgray;
}

.viptab .item .s {
  background: #edd5a7;
  color: #fff;
  width: 75px;
  border-radius: 15px;
  margin: 0 auto;
  height: 17px;
  font-size: 8px;
  line-height: 17px;
}

.submit {
  width: 100%;
  border-radius: 3px;
  padding: 10px 0;
  font-size: 16px;
  color: rgba(255, 235, 59, 1);
  text-align: center;
  font-weight: 600;
  margin-bottom: 10px;
  //   background-image: linear-gradient(to right, #f2dcb7, #e1bb74);
  background: linear-gradient(90deg,
      rgba(255, 129, 119, 1) 0%,
      rgba(255, 134, 122, 1) 0%,
      rgba(255, 140, 127, 1) 21%,
      rgba(249, 145, 133, 1) 52%,
      rgba(207, 85, 108, 1) 78%,
      rgba(177, 42, 91, 1) 100%);
}

.setion {
  padding: 0 10px;
}

.registerTips {
  text-decoration: underline;
  text-align: center;
  color: blue;
  font-size: 14px;
  margin: 6px 0;
}

.setion .title {
  color: #1a1e25;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 14px;

  img {
    width: 15px;
    margin-right: 2px;
  }
}

.setion .h {
  font-size: 13px;
  color: #1a1e25;
  font-weight: 600;
  margin-bottom: 11px;
}

.setion .s {
  color: #969696;
  margin-bottom: 10px;
  font-size: 10px;
}

.headimgUrl {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 10px;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.08);
}

.scaleDraw {
  animation: scaleDraw 2s ease-in-out infinite;
  -webkit-animation: scaleDraw 2s ease-in-out infinite;
}

@keyframes scaleDraw {
  /*定义关键帧、scaleDrew是需要绑定到选择器的关键帧名称*/

  0% {
    transform: scale(1);
    /*开始为原始大小*/
  }

  25% {
    transform: scale(1.1);
    /*放大1.1倍*/
  }

  50% {
    transform: scale(1.2);
  }

  75% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

.vipicon {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.smsize {
  font-size: 10px;
  line-height: 10px;
  position: absolute;
  bottom: -10px;
  left: 0;
  text-align: center;
  right: 0;
  color: #e94d4a;
}
</style>
<style lang="less">
body.pc-mode .vipwrap {
  border-radius: 24px;
  background-size: cover;
}

body.pc-mode .vipwrap .vipPage {
  padding: 28px 24px 0;
}

body.pc-mode .vipwrap .navheader {
  margin-bottom: 22px;
  padding: 24px;
  border-radius: 22px;
  background: rgba(10, 33, 56, 0.18);
  backdrop-filter: blur(10px);
}

body.pc-mode .vipwrap .headimgUrl {
  width: 56px;
  height: 56px;
  margin-right: 14px;
  border: 1px solid rgba(255, 255, 255, 0.56);
}

body.pc-mode .vipwrap .navtitle {
  font-size: 22px;
  font-weight: 700;
}

body.pc-mode .vipSection {
  margin-top: 18px;
  padding: 26px 24px;
  border-radius: 24px;
  box-shadow: 0 18px 36px rgba(29, 67, 108, 0.08);
}

body.pc-mode .vipwrap .viptypetab {
  padding: 10px 0 18px;
  border-bottom: 1px solid rgba(20, 56, 89, 0.08);
}

body.pc-mode .vipwrap .viptypetab .item {
  font-size: 17px;
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 16px;
  margin-top: 20px;
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item {
  margin-right: 0;
  padding: 22px 16px 18px;
  border-radius: 20px;
  box-shadow: 0 14px 30px rgba(29, 67, 108, 0.08);
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease,
    border-color 0.2s ease;
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item:hover {
  transform: translateY(-2px);
  border-color: rgba(34, 96, 154, 0.16);
  box-shadow: 0 20px 38px rgba(29, 67, 108, 0.12);
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item.ac {
  background: linear-gradient(135deg, #fff8d9 0%, #fff1c9 100%);
  border-color: rgba(229, 188, 79, 0.34);
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item .t {
  font-size: 17px;
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item .price {
  font-size: 24px;
}

body.pc-mode .vipwrap .viptab:not(.viptypetab) .item .origin {
  font-size: 12px;
}

body.pc-mode .vipwrap .submit {
  height: 48px;
  margin: 18px 0 14px;
  border-radius: 14px;
  box-shadow: 0 16px 32px rgba(207, 85, 108, 0.22);
}

body.pc-mode .vipwrap .registerTips {
  margin: 10px 0 0;
  color: #1f5da8;
}

body.pc-mode .vipwrap .setion {
  margin-top: 18px;
  padding: 20px 18px 4px;
  border-radius: 20px;
  background: #f7fafc;
}

body.pc-mode .vipwrap .setion .title {
  font-size: 18px;
}

body.pc-mode .vipwrap .setion .h {
  font-size: 14px;
}

body.pc-mode .vipwrap .setion .s {
  font-size: 13px;
  line-height: 1.8;
}
</style>
